import http from 'services/http';
import { generateUrl } from 'utils/url';
import { truncate } from 'lodash-es';

export const addAddress = ({
  lat, lng, label, text, details, deliveryInstructions,
}) => http
  .post('v1/user/address/', {
    title: truncate(label || text, { length: 30 }),
    address: text,
    latitude: lat,
    longitude: lng,
    details,
    delivery_instructions: deliveryInstructions,
  })
  .then(({ data: { data } }) => deserializeAddress(data));

export const editAddress = async ({
  id, lat, lng, label, details, deliveryInstructions, text,
}) => http
  .put(`v1/user/address/${id}/`, {
    title: label || null,
    address: text,
    latitude: lat,
    longitude: lng,
    details,
    delivery_instructions: deliveryInstructions,
  })
  .then(({ data: { data } }) => deserializeAddress(data));

export const getUserAddresses = async ({ lat, lng } = {}) => http
  .get(
    generateUrl({
      url: 'v1/user/address/',
      query: {
        lat,
        lng,
      },
    }),
  )
  .then(({ data: { data } }) => {
    const addresses = data.addresses.map(deserializeAddress);
    const lastAddress = data.last_used_address
      ? deserializeAddress(data.last_used_address)
      : null;
    return {
      addresses,
      lastAddress,
    };
  });
function deserializeAddress({
  id,
  title,
  address,
  location: { lat, lng },
  details,
  delivery_instructions,
}) {
  return {
    lat,
    lng,
    text: address,
    label: title,
    id,
    details,
    deliveryInstructions: delivery_instructions,
  };
}

export const deleteAddress = async (id) => http.delete(generateUrl({
  url: 'v1/user/address/',
  query: { id },
})).then((res) => res.data);
